/** Single UI font stack for shell, drawer, and main content (system fonts, no external load). */
export const SONIC_APP_FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif';
